
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class RetroGridEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, height, width } = pc;
        const spacing = (150 + layerIndex * 50) / (config.parallaxPatternDensity || 1.0);
        
        ctx.strokeStyle = pc.color;
        ctx.lineWidth = 2 * (config.parallaxScale || 1.0);

        const horizon = 0;
        const gridHeight = height * 2;
        const gridWidth = width * 4;

        const draw = () => {
            // Perspective lines
            for (let x = -gridWidth; x <= gridWidth; x += spacing) {
                ctx.beginPath();
                ctx.moveTo(x * 0.1, horizon);
                ctx.lineTo(x, gridHeight);
                ctx.stroke();
            }
            
            // Horizontal lines with exponential spacing
            const lines = Math.floor(20 * (config.parallaxComplexity || 1.0));
            for (let i = 0; i < lines; i++) {
                const y = Math.pow(i / lines, 2) * gridHeight;
                ctx.beginPath();
                ctx.moveTo(-gridWidth, y);
                ctx.lineTo(gridWidth, y);
                ctx.stroke();
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
